import {
  errorLoading, loaded, loading, responseHandler, errorGetStatus, tokenInterceptor,
  uploading, endUploading,
} from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import Constants from '../constants/Constants'
// import { clearRooms } from './ChatWS'

let urlServer = Constants.UrlsConstants.urlServer

let pageAB = 1
let maxPageAB = 1
let limitAB = 1000
let isFetchingAB = false

export const contentWS = (state = {
  contents: [], content: {}, genericTypes: [], personalTypes: [],
  fullDetailSection: {}, RATags: [], AddressBooks: [], contentsTags: [],
  fetchingContentsTags: false,
}, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.CONTENT.SET_CONTENTS:
      return Object.assign({}, state, { contents: action.datas })
    case Constants.ActionsConstants.CONTENT.SET_CONTENT_TAGS:
      return Object.assign({}, state, { contentsTags: action.contentsTags, fetchingContentsTags: false })
    case Constants.ActionsConstants.CONTENT.GET_CONTENT_TAGS:
      return Object.assign({}, state, { fetchingContentsTags: true })
    case Constants.ActionsConstants.CONTENT.SET_CONTENTS_POS:
      let newContent = JSON.parse(JSON.stringify(state.content))
      action.datas.contents.forEach((current) => {
        newContent.contents.forEach((current2) => {
          if (current.id === current2.id) current2.position = current.position
        })
      })
      newContent.contents.sort(function (current1, current2) {
        return current1.position - current2.position
      })
      return Object.assign({}, state, { content: newContent, contentModification: new Date() })
    case Constants.ActionsConstants.CONTENT.SET_CONTENT:
      return Object.assign({}, state, { content: action.datas, contentModification: new Date() })
    case Constants.ActionsConstants.CONTENT.CLEAR_CONTENTS:
      return Object.assign({}, state, {
        contents: [], content: {}, contentModification: new Date(),
        fullDetailSection: {},
      })
    case Constants.ActionsConstants.CONTENT.CLEAR_CONTENT:
      return Object.assign({}, state, { content: {}, contentModification: new Date() })
    case Constants.ActionsConstants.CONTENT.SET_GENERIC_TYPES:
      return Object.assign({}, state, { genericTypes: action.datas })
    case Constants.ActionsConstants.CONTENT.SET_PERSONAL_TYPES:
      return Object.assign({}, state, { personalTypes: action.datas })
    case Constants.ActionsConstants.CONTENT.SET_FULL_DETAIL_SECTIONS:
      return Object.assign({}, state, { fullDetailSection: action.datas })

    case Constants.ActionsConstants.CONTENT.SET_RA_TAGS:
      return Object.assign({}, state, { RATags: action.datas })
    case Constants.ActionsConstants.CONTENT.CLEAR_ADDRESS_BOOKS:
      return Object.assign({}, state, { AddressBooks: [] })
    case Constants.ActionsConstants.CONTENT.SET_ADDRESS_BOOKS:
      return Object.assign({}, state, { AddressBooks: state.AddressBooks.concat(action.datas) })
    default:
      return state
  }
}

export const setGenericTypes = (data) => {
  return {
    type: Constants.ActionsConstants.CONTENT.SET_GENERIC_TYPES,
    datas: data,
  }
}

export const setPersonalTypes = (data) => {
  return {
    type: Constants.ActionsConstants.CONTENT.SET_PERSONAL_TYPES,
    datas: data,
  }
}

export const setContents = (data) => {
  return {
    type: Constants.ActionsConstants.CONTENT.SET_CONTENTS,
    datas: data,
  }
}

export const setContentsPos = (data) => {
  return {
    type: Constants.ActionsConstants.CONTENT.SET_CONTENTS_POS,
    datas: data,
  }
}

export const setContent = (data) => {
  return {
    type: Constants.ActionsConstants.CONTENT.SET_CONTENT,
    datas: data,
  }
}

export const setFullDetailApp = (data) => {
  return {
    type: Constants.ActionsConstants.CONTENT.SET_FULL_DETAIL_SECTIONS,
    datas: data,
  }
}

export const clearContents = () => {
  return {
    type: Constants.ActionsConstants.CONTENT.CLEAR_CONTENTS,
  }
}

export const clearContent = () => {
  return {
    type: Constants.ActionsConstants.CONTENT.CLEAR_CONTENT,
  }
}

export const setRATags = (data) => {
  return {
    type: Constants.ActionsConstants.CONTENT.SET_RA_TAGS,
    datas: data,
  }
}

export const setAddressBooks = (data) => {
  return {
    type: Constants.ActionsConstants.CONTENT.SET_ADDRESS_BOOKS,
    datas: data,
  }
}

export const clearAddressBooks = (data) => {
  return {
    type: Constants.ActionsConstants.CONTENT.CLEAR_ADDRESS_BOOKS,
    datas: [],
  }
}
export const setContentsTags = (contentsTags) => {
  return {
    type: Constants.ActionsConstants.CONTENT.SET_CONTENT_TAGS,
    contentsTags,
  }
}
export const setContentsTagsFetching = () => {
  return {
    type: Constants.ActionsConstants.CONTENT.GET_CONTENT_TAGS,
  }
}

export function clearContentsAction(dispatch) {
  function clrContents() {
    dispatch(clearContents())
  }

  function clrContent() {
    dispatch(clearContent())
  }

  return {
    clrContents,
    clrContent,
  }
}

export function FetchURL(url) {
  function fetchXML() {
    let entryPoint = Constants.UrlsConstants.corsEntryPoint
    return fetch(urlServer + entryPoint + 'xml?url=' + url, {
      method: 'GET',
    })
      .then(r => r.text())
      .then(data => {
        return new DOMParser().parseFromString(data, 'text/xml')
      })
  }

  return {
    fetchXML,
  }
}

export function fetchTypesAction(dispatch) {
  function fetchTypes() {
    fetchGenerics()
    fetchPersonals()
  }

  function fetchGenerics() {
    let entryPoint = Constants.UrlsConstants.sectionEntryPoint
    let method = Constants.MethodsWSConstants.CONTENTS.FETCH_TYPES.GENERICS

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setGenericTypes(data))
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }

  function fetchPersonals() {
    let entryPoint = Constants.UrlsConstants.sectionEntryPoint
    let method = Constants.MethodsWSConstants.CONTENTS.FETCH_TYPES.PERSONALS

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setPersonalTypes(data))
      })
      .catch(error => {
        // dispatch(errorLoading(`${JSON.stringify(error)}`))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }

  return {
    fetchGenerics,
    fetchPersonals,
    fetchTypes,
  }
}

export function fetchContentsAction(dispatch, genericTypes, personalTypes, appid = null, section = null,
  indexOfContent = null) {
  /**
   * Get all section for an app (global section, personnal section and page)
   * genericTypes: list of all global section type
   * personalTypes: list of all personnal section type
   * appid: the current app id
   * content: contains all data [0] for global section, [1] for personnal, [2] for page
   */
  function fetchContents() {
    if (appid) {
      let entryPoint = Constants.UrlsConstants.sectionEntryPoint
      let method = Constants.MethodsWSConstants.CONTENTS.FETCH_CONTENTS + appid

      let contents = []
      Constants.AppsConstants.CONTENTS.SECTIONS.map((item, index) => {
        contents[index] = {
          'type': item,
          'entries': [],
        }
        return null
      })

      return fetch(urlServer + entryPoint + method + '?sort=menuPosition', {
        method: 'GET',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          data.forEach((item) => {
            if (genericTypes.indexOf(item.type) > -1) {
              contents[0].entries.push(item)
            } else if (personalTypes.indexOf(item.type) > -1) {
              contents[1].entries.push(item)
            }
          })
          return contents
        })
        .then((contents) => {
          entryPoint = Constants.UrlsConstants.contentEntryPoint
          return fetch(urlServer + entryPoint + method + '?sort=position', {
            method: 'GET',
            headers: Constants.UrlsConstants.header,
          })
        })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          data.forEach((item) => {
            contents[2].entries.push(item)
          })
          dispatch(setContents(contents))
        })
        .catch(error => {
          // dispatch(errorLoading(method))
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
            // window.location.href='/'
          }
        })
    }
  }

  function fetchContentsTags() {
    if (appid) {
      dispatch(setContentsTagsFetching())
      let entryPoint = Constants.UrlsConstants.sectionTagsEntryPoint
      return fetch(urlServer + entryPoint + appid, {
        method: 'GET',
        headers: Constants.UrlsConstants.header,
      }).then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
        .then(r => r.json())
        .then(data => {
          dispatch(setContentsTags(data))
        })
    }
  }

  function fetchSection() {
    if (section.id) {
      let entryPoint = Constants.UrlsConstants.sectionEntryPoint
      let method = Constants.MethodsWSConstants.CONTENTS.DETAIL_CONTENT + section.id
      let identifier
      if (section.type) {
        // if (section.type === 'CHAT') dispatch(clearRooms())
        identifier = Constants.MethodsWSConstants.CONTENTS['SECTION_CONTENT_' + section.type]
      }
      if (!identifier || identifier === undefined) {
        identifier = Constants.MethodsWSConstants.CONTENTS.SECTION_CONTENT
      }
      return fetch(urlServer + entryPoint + method + identifier, {
        method: 'GET',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          dispatch(setContent(data))
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          }
        })
    } else {
      console.log('section id is empty')
    }
  }

  function fetchContent() {
    let contentToFetch = section.contents[indexOfContent]
    let entryPoint = Constants.UrlsConstants.contentEntryPoint
    let method = Constants.MethodsWSConstants.CONTENTS.DETAIL_CONTENT + contentToFetch.id

    return fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        let index = -1
        section.contents.map((currentContent, currentIdx) => {
          if (currentContent.id === contentToFetch.id) {
            index = currentIdx
          }
          return null
        })
        section.contents[index] = data
        dispatch(setContent(section))
      })
      .catch(error => {
        // dispatch(errorLoading(method))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }

  function setContentToRedux() {
    dispatch(setContent(section))
  }

  function fetchApplicationDetail() {
    // /app/detail/5/APPLICATION_ACTIONS
    let entryPoint = Constants.UrlsConstants.appsEntryPoint
    let method = Constants.MethodsWSConstants.APPS.DETAIL_APP + appid +
      Constants.MethodsWSConstants.APPS.FULL_SECTION_DETAIL

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setFullDetailApp(data))
      })
      .catch(error => {
        // dispatch(errorLoading(method))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }

  function resetContent() {
    dispatch(setContent(null))
  }

  return {
    fetchContents,
    fetchSection,
    fetchContent,
    setContentToRedux,
    fetchApplicationDetail,
    resetContent,
    fetchContentsTags,
  }
}

export function SaveDeleteContentActions(dispatch, content, type, genericTypes, personalTypes, appid, indexOfContent) {
  function saveManifest() {
    dispatch(loading(''))
    let entryPoint = Constants.UrlsConstants.sectionEntryPoint
    let method = Constants.MethodsWSConstants.CONTENTS.UPDATE_PLUGIN_MANIFEST
    return fetch(urlServer + entryPoint + method, {
      method: 'PUT',
      body: JSON.stringify(content),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setContent(data))
        return fetchContentsAction(dispatch, genericTypes, personalTypes, appid, null).fetchContents().then(() => {
          dispatch(loaded('Error.Croutons.saveSuccess'))
        })
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function saveSection() {
    dispatch(loading(''))
    let entryPoint = Constants.UrlsConstants.sectionEntryPoint
    let method
    if (!content.id) {
      // Create new Section (generic or personal)
      if (genericTypes.indexOf(content.type) > -1) {
        method = Constants.MethodsWSConstants.CONTENTS.CREATE_GENERIC + appid
      } else if (personalTypes.indexOf(content.type) > -1) {
        method = Constants.MethodsWSConstants.CONTENTS.CREATE_PERSONAL + appid
      }
    } else {
      if (content.type) {
        method = Constants.MethodsWSConstants.CONTENTS['UPDATE_CONTENT_' + content.type]
      }
      if (!method || method === undefined) {
        method = Constants.MethodsWSConstants.CONTENTS.UPDATE_CONTENT
      }
    }
    if (content.params && typeof content.params !== 'string') content.params = JSON.stringify(content.params)

    return fetch(urlServer + entryPoint + method, {
      method: content.id ? 'PUT' : 'POST',
      body: JSON.stringify(content),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setContent(data))
        return fetchContentsAction(dispatch, genericTypes, personalTypes, appid, null).fetchContents().then(() => {
          return fetchContentsAction(dispatch, null, null, appid, null).fetchContentsTags().then(() => {
            dispatch(loaded('Error.Croutons.saveSuccess'))
          })
        })
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function duplicateSection() {
    dispatch(loading(''))
    let entryPoint = Constants.UrlsConstants.sectionEntryPoint
    let method = Constants.MethodsWSConstants.CONTENTS.DUP_CONTENT

    fetch(urlServer + entryPoint + method + content.id, {
      method: 'POST',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setContent(data))
        fetchContentsAction(dispatch, genericTypes, personalTypes, appid, null).fetchContents().then(result => {
          dispatch(loaded('Error.Croutons.saveSuccess'))
        })
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function updateContentsPosition() {
    let entryPoint = Constants.UrlsConstants.sectionEntryPoint
    let method = Constants.MethodsWSConstants.CONTENTS.UPDATE_CONTENTS_POS
    let sectionPositions = { id: content.id, contents: [] }
    content.contents.map((current, index) => {
      sectionPositions.contents.push({ id: current.id, position: index })
      return null
    })
    fetch(urlServer + entryPoint + method, {
      method: 'PUT',
      body: JSON.stringify(sectionPositions),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setContentsPos(data))
        dispatch(loaded('Error.Croutons.saveSuccess'))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteSection() {
    let entryPoint = Constants.UrlsConstants.sectionEntryPoint
    let method = content.id

    dispatch(loading(''))
    fetch(urlServer + entryPoint + method, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then((datas) => {
        // On met à jour la liste des sections dans le sous-menu
        dispatch(setContent({}))
        fetchContentsAction(dispatch, genericTypes, personalTypes, appid).fetchContents().then(result => {
          // On change de section (la précédente ou vide)
          if (indexOfContent) {
            fetchContentsAction(dispatch, genericTypes, personalTypes, appid,
              indexOfContent).fetchSection().then(() => {
                dispatch(loaded('Error.Croutons.deleteSuccess'))
              })
          } else {
            dispatch(clearContent())
            dispatch(loaded('Error.Croutons.deleteSuccess'))
          }
        })
      })
      .catch(error => {
        // dispatch(errorLoading('error in delete'))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  function savePage() {
    let contentToSave = content.contents[indexOfContent]
    let entryPoint = Constants.UrlsConstants.contentEntryPoint
    let create = !contentToSave.id
    let method = ''
    if (create) {
      // Create new page
      method = Constants.MethodsWSConstants.CONTENTS.CREATE_PAGE + appid
    }
    fetch(urlServer + entryPoint + method, {
      method: create ? 'POST' : 'PUT',
      body: JSON.stringify(contentToSave),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        let newSection = { contents: [data] }
        fetchContentsAction(dispatch, null, null, null, newSection, 0).fetchContent().then(() => {
          fetchContentsAction(dispatch, genericTypes, personalTypes, appid, null).fetchContents()
        })
      })
      .catch(error => {
        // dispatch(errorLoading(method))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deletePage() {
    dispatch(loading(''))
    let entryPoint = Constants.UrlsConstants.contentEntryPoint
    fetch(urlServer + entryPoint + content.id, {
      method: 'DELETE',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(data => {
        // On met à jour la liste des sections dans le sous-menu
        fetchContentsAction(dispatch, genericTypes, personalTypes, appid).fetchContents().then(() => {
          // On change de page (la précédente ou vide)
          if (indexOfContent) {
            let section = { contents: [indexOfContent] }
            fetchContentsAction(dispatch, genericTypes, personalTypes, appid, section, 0).fetchContent().then(() => {
            })
          } else {
            dispatch(clearContent())
          }
          dispatch(loaded('Error.Croutons.deleteSuccess'))
        })
      })
      .catch(error => {
        // dispatch(errorLoading('deleteContent'))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.deleteError'))
        }
      })
  }

  function saveContent() {
    let contentToSave = content.contents[indexOfContent]
    let entryPoint = Constants.UrlsConstants.contentEntryPoint
    let create = !contentToSave.id
    let method = ''
    if (create) {
      // Add new content
      method = Constants.MethodsWSConstants.CONTENTS.CREATE_CONTENT + content.id
    }
    if (contentToSave.content && contentToSave.content && contentToSave.content.translations) {
      contentToSave.content.translations.forEach(item => {
        let translation = item.translation
        let regex = /(<*([^>]+)>)/ig
        let htmlTags = translation.match(regex)
        if (htmlTags && htmlTags.length) {
          htmlTags.map((tag, index) => {
            if (tag.indexOf('<img') > -1) {
              let regexDataImageID = /data-imageid="([^"]*)"/
              let dataID = tag.match(regexDataImageID)
              if (dataID) {
                dataID = parseInt(dataID[1], 0)
                let newTag = '<image data-imageid="' + dataID + '"/>'
                if (tag.indexOf('<img') === 0) {
                  htmlTags[index] = newTag
                } else {
                  htmlTags[index] = tag.substr(0, tag.indexOf('<img') - 1) + '<br>' + newTag
                }
              } else {
                let regexDataImageID = /src="([^"]*)"/
                let src = tag.match(regexDataImageID)
                if (src) {
                  let splitted = src[1].split('/')
                  let dataID = splitted[splitted.length - 1].split('?')[0]

                  let newTag = '<image data-imageid="' + dataID + '"/>'
                  if (tag.indexOf('<img') === 0) {
                    htmlTags[index] = newTag
                  } else {
                    htmlTags[index] = tag.substr(0, tag.indexOf('<img') - 1) + '<br>' + newTag
                  }
                }
              }
            }
            return null
          })
          item.translation =
            htmlTags.join('')
        }
      })
    }
    console.log(contentToSave)
    fetch(urlServer + entryPoint + method, {
      method: create ? 'POST' : 'PUT',
      body: JSON.stringify(contentToSave),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        if (!contentToSave.id) {
          // If new Content, set the id
          content.contents[content.contents.length - 1].id = data.id
        }
        fetchContentsAction(dispatch, null, null, null, content, indexOfContent).fetchContent()
      })
      .catch(error => {
        // dispatch(errorLoading(method))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function notifyContent() {
    let contentToSave = content.contents[indexOfContent]
    let entryPoint = Constants.UrlsConstants.contentEntryPoint
    let method = Constants.MethodsWSConstants.CONTENTS.NOTIFY_CONTENT
    let now = new Date().getTime()
    if (contentToSave.publication && contentToSave.publication > now) {
      contentToSave.publication = now
    }
    let notifyContent = {
      id: contentToSave.id, toBePushed: true,
      publication: contentToSave.publication, notification: now,
    }
    fetch(urlServer + entryPoint + method, {
      method: 'PUT',
      body: JSON.stringify(notifyContent),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchContentsAction(dispatch, null, null, null, content, indexOfContent).fetchContent()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function duplicateContent() {
    let contentToSave = content.contents[indexOfContent]
    let entryPoint = Constants.UrlsConstants.contentEntryPoint
    let method = Constants.MethodsWSConstants.CONTENTS.DUP_CONTENT

    fetch(urlServer + entryPoint + method + contentToSave.id, {
      method: 'POST',
      body: JSON.stringify(notifyContent),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(loaded('Error.Croutons.saveSuccess'))
        fetchContentsAction(dispatch, null, null, null, content).fetchSection()
      })
      .catch(error => {
        // dispatch(errorLoading(method))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function duplicatePage() {
    let contentToSave = content.contents[indexOfContent]
    let entryPoint = Constants.UrlsConstants.contentEntryPoint
    let method = Constants.MethodsWSConstants.CONTENTS.DUP_CONTENT

    dispatch(loading(''))
    fetch(urlServer + entryPoint + method + contentToSave.id, {
      method: 'POST',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        let newSection = { contents: [data] }
        fetchContentsAction(dispatch, null, null, null, newSection, 0).fetchContent().then(() => {
          fetchContentsAction(dispatch, genericTypes, personalTypes, appid, null).fetchContents().then(() => {
            dispatch(loaded('Error.Croutons.saveSuccess'))
          })
        })
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.saveError'))
        }
      })
  }

  function deleteContent() {
    if (content.contents[indexOfContent].id) {
      let contentToDelete = content.contents[indexOfContent]
      let entryPoint = Constants.UrlsConstants.contentEntryPoint

      fetch(urlServer + entryPoint + contentToDelete.id, {
        method: 'DELETE',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(data => {
          dispatch(loaded('Error.Croutons.deleteSuccess'))
          fetchContentsAction(dispatch, null, null, null, content).fetchSection()
        })
        .catch(error => {
          // dispatch(errorLoading('deleteContent'))
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
            // window.location.href='/'
          } else {
            dispatch(errorLoading('Error.Croutons.deleteError'))
          }
        })
    }
  }

  return {
    saveManifest,
    saveSection,
    duplicateSection,
    updateContentsPosition,
    deleteSection,
    savePage,
    deletePage,
    saveContent,
    notifyContent,
    duplicateContent,
    duplicatePage,
    deleteContent,
  }
}

export function fetchSectionPositionAction(dispatch, menuPosition, genericTypes, personalTypes, appid = null) {
  function saveMenuPosition() {
    if (appid) {
      let entryPoint = Constants.UrlsConstants.sectionEntryPoint
      let method = Constants.MethodsWSConstants.CONTENTS.UPDATE_MENU_POSITION

      fetch(urlServer + entryPoint + method, {
        method: 'PUT',
        body: JSON.stringify(menuPosition),
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          fetchContentsAction(dispatch, genericTypes, personalTypes, appid, null)
            .fetchContents()
        })
        .catch(error => {
          // dispatch(errorLoading(method))
          if (errorGetStatus(error) === 401) {
            fetchLogoutAction(dispatch).fetchLogout()
            // window.location.href='/'
          }
        })
    }
  }

  return {
    saveMenuPosition,
  }
}

export function fetchRATagsAction(dispatch, tagid = null, sectionID = null) {
  function fetchTags() {
    let entryPoint = Constants.UrlsConstants.raEntryPoint
    let method = Constants.MethodsWSConstants.RA.FETCH_TAGS

    fetch(urlServer + entryPoint + method, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setRATags(data))
      })
      .catch(error => {
        // dispatch(errorLoading(method))
        if (errorGetStatus(error) === 401) {
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }

  function deleteTag() {
    if (tagid && sectionID) {
      let entryPoint = Constants.UrlsConstants.raEntryPoint
      let method = Constants.MethodsWSConstants.RA.DELETE_TAG + tagid

      fetch(urlServer + entryPoint + method, {
        method: 'DELETE',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        // .then(r => r.json())
        .then(data => {
          // dispatch(setRATags(data))
          fetchContentsAction(dispatch, null, null, null, { id: sectionID, type: 'RA' }).fetchSection()
        })
        .catch(error => {
          // dispatch(errorLoading(method))
          if (errorGetStatus(error) === 401) {
            fetchLogoutAction(dispatch).fetchLogout()
            // window.location.href='/'
          }
        })
    }
  }

  return {
    fetchTags,
    deleteTag,
  }
}

export function fetchAddressBooksAction(dispatch, sectionID = null, entry = null) {
  function clearAB() {
    pageAB = 1
    maxPageAB = 1
    dispatch(clearAddressBooks([]))
  }

  function fetchAB() {
    if (!isFetchingAB && pageAB <= maxPageAB) {
      isFetchingAB = true
      if (sectionID) {
        let entryPoint = Constants.UrlsConstants.addressBookEntryPoint
        let method = Constants.MethodsWSConstants.ADDRESS_BOOKS.GET
        method += sectionID + '?page=' + pageAB + '&size=' + limitAB + '&sort=name' // TODO Paginate

        fetch(urlServer + entryPoint + method, {
          method: 'GET',
          headers: Constants.UrlsConstants.header,
        })
          .then(response => {
            tokenInterceptor(response)
            return responseHandler(response)
          })
          .then(r => r.json())
          .then(data => {
            isFetchingAB = false
            maxPageAB = data.totalPages
            if (maxPageAB >= pageAB) pageAB++
            dispatch(setAddressBooks(data.content))
          })
          .catch(error => {
            isFetchingAB = false
            // dispatch(errorLoading(method))
            if (errorGetStatus(error) === 401) {
              fetchLogoutAction(dispatch).fetchLogout()
              // window.location.href='/'
            }
          })
      }
    }
  }

  function addUpdateAB() {
    if (sectionID && entry) {
      let entryPoint = Constants.UrlsConstants.addressBookEntryPoint
      let method = Constants.MethodsWSConstants.ADDRESS_BOOKS.ADD + sectionID
      if (entry.id) {
        method = Constants.MethodsWSConstants.ADDRESS_BOOKS.UPDATE
      }

      fetch(urlServer + entryPoint + method, {
        method: entry.id ? 'PUT' : 'POST',
        body: JSON.stringify(entry),
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          dispatch(loaded('Error.Croutons.saveSuccess'))
          fetchContentsAction(dispatch, null, null, null, { id: sectionID, type: 'ANNUAIRE' }).fetchSection()
          clearAB()
          fetchAB()
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
            // window.location.href='/'
          } else {
            dispatch(errorLoading('Error.Croutons.saveError'))
          }
        })
    }
  }

  function deleteAB() {
    if (entry && sectionID) {
      let entryPoint = Constants.UrlsConstants.addressBookEntryPoint
      let method = Constants.MethodsWSConstants.ADDRESS_BOOKS.DELETE + entry.id

      fetch(urlServer + entryPoint + method, {
        method: 'DELETE',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        // .then(r => r.json())
        .then(data => {
          dispatch(loaded('Error.Croutons.deleteSuccess'))
          fetchContentsAction(dispatch, null, null, null, { id: sectionID, type: 'ANNUAIRE' }).fetchSection()
          clearAB()
          fetchAB()
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
            // window.location.href='/'
          } else {
            dispatch(errorLoading('Error.Croutons.deleteError'))
          }
        })
    }
  }

  return {
    clearAB,
    fetchAB,
    deleteAB,
    addUpdateAB,
  }
}

export function uploadMediasForRA(dispatch, raMarker = null, raVideo = null, raImage = null, sectionID) {
  function uploadForMarker() {
    if (raMarker && (raVideo || raImage) && sectionID) {
      let entryPoint = Constants.UrlsConstants.raEntryPoint + 'video/'
      let method = Constants.MethodsWSConstants.MEDIAS.ADD_MEDIA + raMarker
      let formData = new FormData()
      if (raVideo) {
        formData.append('video', raVideo)
      }
      if (raImage) {
        formData.append('image', raImage)
      }

      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      }

      fetch(urlServer + entryPoint + method, {
        method: 'POST',
        body: formData,
        headers,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        // .then(r => r.json())
        .then(data => {
          dispatch(loaded('Error.Croutons.uploadSuccess'))
          fetchContentsAction(dispatch, null, null, null, { id: sectionID, type: 'RA' }).fetchSection()
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          } else {
            dispatch(errorLoading('Error.Croutons.uploadFail'))
          }
        })
    }
  }

  return {
    uploadForMarker,
  }
}

export function uploadZipForSection(dispatch, file, sectionID, locale, conservePluginConf) {
  function upload() {
    if (file && sectionID) {
      let entryPoint = Constants.UrlsConstants.pluginEntryPoint
      let method = Constants.MethodsWSConstants.MEDIAS.ADD_MEDIA + sectionID
      let formData = new FormData()
      formData.append('file', file)
      formData.append('locale', locale)
      formData.append('conservePluginConf', conservePluginConf)

      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      }

      dispatch(uploading())

      return fetch(urlServer + entryPoint + method, {
        method: 'POST',
        body: formData,
        headers,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          return fetchContentsAction(dispatch, null, null, null, { id: sectionID, type: 'PLUGIN' })
            .fetchSection().then(() => {
              if (data.length) {
                dispatch(errorLoading('Error.Croutons.uploadConfigInvalid'))
              } else {
                dispatch(endUploading())
              }
              return data
            })
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          } else {
            dispatch(errorLoading('Error.Croutons.uploadFail'))
          }
        })
    }
  }

  return {
    upload,
  }
}
